export class AuthHistory {
    author: string;
    comment: string;
    _id: string;
    date: string;
    action: string;
}
